<template>
  <div>
    <a>
      <img v-bind:src="photo.zoom" @click="show" :title="photo.filename"/>
      <div class="caption caption-top">
        <div class="top-tools">
          <a class="download-free" @click="download" v-if="free" :title="$t('photo.download')">
            <i class="fa fa-arrow-down"></i>
          </a>
          <a class="share-social-media" @click="share" v-if="free && socialShare" :title="$t('photo.share')">
            <i class="fa fa-share-alt"></i>
          </a>
        </div>
      </div>
      <div class="caption caption-bottom">
        <ul class="tools">
          <li v-if="photo.selected">
            <a class="favorite" :title="$t('photo.removeFromFavorites')" @click="remove" v-bind:style="display">
              <i class="fa fa-heart"></i>
            </a>
          </li>
          <li v-if="!photo.selected">
            <a class="favorite" :title="$t('photo.addToFavorites')" @click="add">
              <i class="fa fa-heart-o"></i>
            </a>
          </li>
          <li v-if="!free">
            <a class="cart" :title="$t('photo.addToCart')" @click="cart">
              <i class="fa fa-shopping-cart"></i>
            </a>
          </li>
        </ul>
      </div>
      <SocialMedia
        :activeShareMedia="activeShare"
        :photo="photo"
        @closeSocialMedia="closeSocialMedia" />
    </a>
  </div>
</template>

<script>
import PhotoMixing from '../mixins/PhotoMixin.vue'
import SocialMedia from "../components/SocialMedia"

export default {
  name: "FavoritePhoto",
  mixins: [PhotoMixing],
  components: {
    SocialMedia
  },
  props: {
    shareSocialMedia: {
      type: Boolean,
      default: false
    }
  },
  methods:  {
    async download() {
      await this.downloadPhoto(this.currentPhoto);
    },
    async remove() {
      this.$root.$emit('FavoritesRemovePhoto', this.photo)
      this.currentPhoto.removeFavorite(this.parameters).then(() => {})
        .catch((error) => {
          console.log(error)
        })
    },
    cart() {
      this.$root.$emit('FavoritesAddPhotoToCart', this.photo)
    },
    show() {
      //this.$root.$emit('openZoom', this.photo);
    }
  },
  computed: {
    socialShare() {
      return this.shareSocialMedia;
    },
  }
}
</script>
